// extracted by mini-css-extract-plugin
export var blink = "_7d-2";
export var cursor = "_7d-1";
export var reactMarkdown = "_7d-3";
export var streamingText = "_7d-0";